import { PerformanceServerTiming, ResourceEntryType } from '@ms/yammer-telemetry/dist/performance';

import { getTelemetryClientConfig } from '../telemetryStore';

const ecsResourcePrefix = 'https://ecs.office.com/config/v1/YammerClients';
const operationNameServerTimingKey = 'opName';
const requestIdServerTimingKey = 'xReqId';

const getValueFromServerTiming = (serverTiming: PerformanceServerTiming[], name: string) => {
  const record = serverTiming && serverTiming.find((timing) => timing.name === name);

  return record && record.description;
};

type GetOperationNameFromServerTiming = (serverTiming: PerformanceServerTiming[]) => string | undefined;
export const getOperationNameFromServerTiming: GetOperationNameFromServerTiming = (serverTiming) =>
  getValueFromServerTiming(serverTiming, operationNameServerTimingKey);

type GetRequestIdFromServerTiming = (serverTiming: PerformanceServerTiming[]) => string | undefined;
export const getRequestIdFromServerTiming: GetRequestIdFromServerTiming = (serverTiming) =>
  getValueFromServerTiming(serverTiming, requestIdServerTimingKey);

const isGraphqlResourceEntry = ({ name }: PerformanceResourceTiming) =>
  name.startsWith(`${getTelemetryClientConfig().graphqlHost}/graphql`);

const isJavaScriptResourceEntry = ({ name }: PerformanceResourceTiming) => name.endsWith('.js');

const isFlightingResourceEntry = ({ name }: PerformanceResourceTiming) => name.startsWith(ecsResourcePrefix);

type GetResourceEntryType = (resourceEntry: PerformanceResourceTiming) => ResourceEntryType;
export const getResourceEntryType: GetResourceEntryType = (resourceEntry) => {
  if (isGraphqlResourceEntry(resourceEntry)) {
    return ResourceEntryType.GraphQL;
  }

  if (isJavaScriptResourceEntry(resourceEntry)) {
    return ResourceEntryType.JavaScript;
  }

  if (isFlightingResourceEntry(resourceEntry)) {
    return ResourceEntryType.Flighting;
  }

  return ResourceEntryType.Unknown;
};
